export const WRONG_DATA_ERROR = "error.wrong_data";
export const SERVER_ERROR = "error.server";
export const NETWORK_ERROR = "error.network";
export const USER_BY_EMAIL_ERROR = "error.user_by_email";
export const FILE_MAX_SIZE_ERROR = "error.file_max_size";
export const UNABLE_TO_DELETE_COURSE = "error.unable_to_delete";
